module.exports = __webpack_public_path__ + "img/03_img.f86935cf.png";